import { render, staticRenderFns } from "./ArkemaUsers.vue?vue&type=template&id=8f09b67c&scoped=true"
import script from "./ArkemaUsers.vue?vue&type=script&lang=ts"
export * from "./ArkemaUsers.vue?vue&type=script&lang=ts"
import style0 from "./ArkemaUsers.vue?vue&type=style&index=0&id=8f09b67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f09b67c",
  null
  
)

export default component.exports